/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramGeoControllerGetDistrictsQueryResponse,
  TelegramGeoControllerGetDistrictsPathParams,
} from '../../types/TelegramGeoControllerGetDistricts.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramGeoGetDistricts } from '../../methods/telegramGeoGetDistricts.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramGeoGetDistrictsQueryKey = (cityId: TelegramGeoControllerGetDistrictsPathParams['cityId']) =>
  [{ url: '/api/telegram/geo/districts/:cityId', params: { cityId: cityId } }] as const;

export type TelegramGeoGetDistrictsQueryKey = ReturnType<typeof telegramGeoGetDistrictsQueryKey>;

export function telegramGeoGetDistrictsQueryOptions(
  cityId: TelegramGeoControllerGetDistrictsPathParams['cityId'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramGeoGetDistrictsQueryKey(cityId);
  return queryOptions<
    TelegramGeoControllerGetDistrictsQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramGeoControllerGetDistrictsQueryResponse,
    typeof queryKey
  >({
    enabled: !!cityId,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramGeoGetDistricts(cityId, config);
    },
  });
}

/**
 * {@link /api/telegram/geo/districts/:cityId}
 */
export function useTelegramGeoGetDistricts<
  TData = TelegramGeoControllerGetDistrictsQueryResponse,
  TQueryData = TelegramGeoControllerGetDistrictsQueryResponse,
  TQueryKey extends QueryKey = TelegramGeoGetDistrictsQueryKey,
>(
  cityId: TelegramGeoControllerGetDistrictsPathParams['cityId'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramGeoControllerGetDistrictsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramGeoGetDistrictsQueryKey(cityId);

  const query = useQuery(
    {
      ...telegramGeoGetDistrictsQueryOptions(cityId, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
